import { useState } from 'react'
import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Stack,
  Button,
  TextField
} from '@mui/material'
import { OkIcon } from 'shared/icons'

import { Section } from 'components/controls/section'
import { DialogBase } from 'components/dialog'
import { FormatTypes } from '../types'

export interface GridDownloadParams {
  fileName: string
  format: FormatTypes
}
type GridDownloadDialogProps = {
  downloading: boolean
  fileName: string
  onDownload: (params: GridDownloadParams) => void
  onClose: () => void
}
export const GridDownloadDialog = ({
  downloading,
  fileName: defaultFileName,
  onDownload,
  onClose
}: GridDownloadDialogProps) => {
  const [fileName, setFileName] = useState<string>(defaultFileName)
  const [format, setFormat] = useState<FormatTypes>('excel')
  return (
    <DialogBase
      open
      fullWidth
      maxWidth="sm"
      title="ダウンロード"
      isLoading={downloading}
      body={
        <Stack direction="column">
          <FormControl>
            <Section label="形式" labelProps={{ paddingY: 2 }}>
              <RadioGroup
                value={format}
                name="download-format"
                onChange={(e) => setFormat(e.target.value as FormatTypes)}
              >
                <FormControlLabel
                  value="excel"
                  control={<Radio />}
                  label="EXCEL"
                />
                <FormControlLabel
                  value="csv"
                  control={<Radio />}
                  label="CSV"
                />
                <FormControlLabel
                  value="tsv"
                  control={<Radio />}
                  label="TSV"
                />
                <FormControlLabel
                  value="clipboard"
                  control={<Radio />}
                  label="クリップボード"
                />
              </RadioGroup>
            </Section>
          </FormControl>

          <FormControl>
            <Section label="ファイル名" labelProps={{ paddingY: 2 }}>
              <TextField
                hiddenLabel
                fullWidth
                variant="outlined"
                size="small"
                disabled={format === 'clipboard'}
                value={fileName}
                onChange={(event) => setFileName(event.target.value)}
              />
            </Section>
          </FormControl>
        </Stack>
      }
      action={{
        right: (<>
          <Button variant="contained" type="submit" startIcon={<OkIcon />} onClick={(event) => {
            event.preventDefault()
            onDownload({ fileName, format })            
          }}>
            実 行
          </Button>
          <Button variant="text" onClick={onClose}>
            キャンセル
          </Button>
        </>)
      }}
      onClose={() => {
        if (!downloading) onClose()
      }}
    />
  )
}
